<template>
    <router-link :to="link" class="arrow-btn">
        <span class="page-text font-weight-bold">더보기</span>
        <div class="arrow-wrap">
            <i class="icon icon-right-arrow2"></i>
        </div>
    </router-link>
</template>

<script>

export default{
    props : {
        link : {type :String, default : ""}
    },
	components: {

	},
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
	// 	}
	// },
}
</script>

<style scoped>
.arrow-btn{
    width: 100px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.arrow-btn .arrow-wrap{
    padding-right: 12px;
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
}

.arrow-btn .arrow-wrap::before{
    content: "";
    display: block;
    position: absolute;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 1px solid #d2dee4;
    right: 0;
    top: 0;
    transition: 0.15s ease-out;
}

.arrow-btn .arrow-wrap i{
    position: relative;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .arrow-btn{
        width: 120px;
        height: 50px;
    }

    .arrow-btn .arrow-wrap{
        padding-right: 20px;
    }

    .arrow-btn .arrow-wrap::before{
        width: 50px;
        height: 50px;
    }

    .arrow-btn:hover .arrow-wrap::before{
        background-color: #ebf5ff;
    }
}
@media (min-width:1200px){
}

</style>